import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import styles from './secondStyles';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import Section from '../../shared/Section/Section';

function QuestionsContent({ ymEvents = {}, first, second }) {
  return (
    <Section customStyles={styles.section}>
      <Box sx={styles.contentWrapper}>
        <Link href="/career/" underline="none">
          <Button
            variant="kitPrimary"
            size="large"
            component="span"
            tabIndex={-1}
            sx={styles.leftLink}
          >
            {first.title || 'получить консультацию'}
          </Button>
        </Link>
        <Link href="/#program" sx={styles.rightLink}>
          <Button
            onClick={() =>
              sendYandexMetrikaEvent(ymEvents.mainProgrammsBottomClick)
            }
            variant="outlined"
            size="large"
            sx={{ p: { xs: '8px 16px 8px 16px', lg: '12px 30px 12px 30px' } }}
          >
            {second.title || 'посмотреть программы'}
          </Button>
        </Link>
      </Box>
    </Section>
  );
}

export default QuestionsContent;
